import React from 'react';
import { Phone, MapPin, Instagram, Facebook, ArrowUp } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="iletisim" className="bg-black border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          
          {/* Brand */}
          <div className="space-y-6 col-span-1 md:col-span-1">
            <Link to="/" onClick={scrollToTop} className="block">
                <h3 className="text-3xl font-black text-white tracking-tighter">
                    ŞAHİN <span className="text-yellow-500">VIP</span>
                </h3>
                <span className="text-[10px] tracking-[0.4em] text-gray-400 uppercase">
                    Transfer Hizmetleri
                </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Antalya'nın her noktasına 7/24 VIP transfer hizmeti. 
              Konforlu, güvenli ve zamanında ulaşım için doğru adres.
            </p>
            <div className="flex gap-4">
                <a href="https://www.instagram.com/koparansahin?igsh=MWMzaGd5bjRoc3pjeQ==" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-3 rounded-full hover:bg-yellow-500 hover:text-black transition-colors text-white">
                    <Instagram className="h-5 w-5" />
                </a>
                <a href="https://www.facebook.com/share/17xjjTzz7w/" target="_blank" rel="noopener noreferrer" className="bg-white/5 p-3 rounded-full hover:bg-blue-600 hover:text-white transition-colors text-white">
                    <Facebook className="h-5 w-5" />
                </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h4 className="text-lg font-bold text-white uppercase tracking-wider">Hızlı Erişim</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
                <li><Link to="/" onClick={scrollToTop} className="hover:text-yellow-500 transition-colors flex items-center gap-2">Ana Sayfa</Link></li>
                <li><Link to="/filo" onClick={scrollToTop} className="hover:text-yellow-500 transition-colors flex items-center gap-2">Araç Filomuz</Link></li>
                <li><Link to="/fiyatlar" onClick={scrollToTop} className="hover:text-yellow-500 transition-colors flex items-center gap-2">Fiyat Listesi</Link></li>
                <li><Link to="/iletisim" onClick={scrollToTop} className="hover:text-yellow-500 transition-colors flex items-center gap-2">İletişim</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-6">
            <h4 className="text-lg font-bold text-white uppercase tracking-wider">Hizmet Bölgeleri</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
                <li><Link to="/fiyatlar" className="hover:text-yellow-500 transition-colors">Antalya Havalimanı Transfer</Link></li>
                <li><Link to="/fiyatlar" className="hover:text-yellow-500 transition-colors">Belek VIP Transfer</Link></li>
                <li><Link to="/fiyatlar" className="hover:text-yellow-500 transition-colors">Alanya VIP Transfer</Link></li>
                <li><Link to="/fiyatlar" className="hover:text-yellow-500 transition-colors">Side / Manavgat Transfer</Link></li>
                <li><Link to="/fiyatlar" className="hover:text-yellow-500 transition-colors">Kemer / Göynük Transfer</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="text-lg font-bold text-white uppercase tracking-wider">İletişim</h4>
            <div className="space-y-4">
                <a href="tel:+905468953037" className="flex items-center gap-4 text-gray-300 hover:text-white transition-colors group p-3 bg-white/5 rounded-xl border border-transparent hover:border-yellow-500/30">
                    <div className="bg-yellow-500/10 p-2 rounded-lg group-hover:bg-yellow-500 group-hover:text-black transition-colors text-yellow-500">
                        <Phone className="h-5 w-5" />
                    </div>
                    <span className="font-bold">0546 895 30 37</span>
                </a>
                <div className="flex items-center gap-4 text-gray-300 group p-3">
                    <div className="bg-white/5 p-2 rounded-lg text-gray-400">
                        <MapPin className="h-5 w-5" />
                    </div>
                    <span>Antalya, Türkiye</span>
                </div>
            </div>
            <a href="https://wa.me/905468953037" target="_blank" rel="noopener noreferrer">
                <Button className="w-full mt-2 bg-green-600 hover:bg-green-700 text-white py-6 text-lg font-bold shadow-lg shadow-green-900/20">
                    WhatsApp'tan Yazın
                </Button>
            </a>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
                © 2024 Şahin VIP Transfer. Tüm hakları saklıdır.
            </p>
            <button onClick={scrollToTop} className="flex items-center gap-2 text-sm text-gray-500 hover:text-yellow-500 transition-colors">
                Yukarı Çık <ArrowUp className="h-4 w-4" />
            </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
